module.exports = __webpack_public_path__ + "img/graph-1a.4d43d7c4.png";